import { useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

import BackButton from '~/math-vault/components/Buttons/BackButton'
import MathVaultIntro, { onClickBackButton } from '~/math-vault/pages/MathVaultIntro.page'
import MathVaultClearLayout from '~/shared/layouts/MathVaultClearLayout'
import Metatags from '~/components/Metadata/Metatags'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import ROUTES from '~/shared/constants/routes.const'
import { Ii18nLocales } from '~/types/i18n'
import { Link } from '~/components/Link'
import { localesForPlayCanvas } from '~/shared/sanity/locales'
import { usePageTitle } from '~/utils/tags'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
const mediaQuery = [
  { screen: '(max-width: 640px)', width: '32px' },
  { screen: '(min-width: 641px)', width: '56px' },
]

export default function MathVaultSitemap({ playLocales }: { playLocales: Ii18nLocales }): React.ReactElement {
  const { t } = useTranslation('mathVault')
  const [showBackButton, setShowBackButton] = useState(false)
  const route = useRouter()
  const showSitemap = route.pathname === ROUTES.MATH_VAULT

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={usePageTitle(t('title'))} />

      <MathVaultClearLayout
        leftAddon={
          showBackButton && (
            <div className="fixed left-2 sm:left-5 z-modal">
              <BackButton onClick={() => onClickBackButton({ onClick: 'back-button' })} />
            </div>
          )
        }
        rightAddon={
          showSitemap && (
            <>
              <Link
                className="absolute flex items-center justify-end gap-1 right-2 sm:right-5 text-xs sm:text-2xl w-20 sm:w-auto text-right"
                to={ROUTES.MATH_VAULT_SITE_MAP}
              >
                <ResponsiveImage
                  alt="math vault sitemap"
                  height={56}
                  imageClassName="min-w-5.5 w-8 sm:w-14"
                  imageWidths="32, 56"
                  mediaQuery={mediaQuery}
                  srcKey="Math Vault/icons/shortcut-arrow.png"
                  width={56}
                />
                {t('siteMap')}
              </Link>
            </>
          )
        }
      >
        <div className="flex flex-col">
          <MathVaultIntro playLocales={playLocales} setShowBackButton={setShowBackButton} />
        </div>
      </MathVaultClearLayout>
    </div>
  )
}

export const getProps: GetProps = () => async () => {
  const playLocales = await localesForPlayCanvas()

  return {
    props: {
      playLocales,
      namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'mathVault'],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)
